import { createFileRoute, redirect } from '@tanstack/react-router';

import { requireAuth } from '@/app/lib/auth-guard';

export const Route = createFileRoute('/usage/')({
  beforeLoad: async (ctx) => {
    await requireAuth(ctx);
  },
  loader: () => {
    throw redirect({
      to: '/usage/electric'
    });
  }
});
